import { render, staticRenderFns } from "./modifyInformation.vue?vue&type=template&id=543c17b5&scoped=true&lang=html&"
import script from "./modifyInformation.vue?vue&type=script&lang=js&"
export * from "./modifyInformation.vue?vue&type=script&lang=js&"
import style0 from "./modifyInformation.vue?vue&type=style&index=0&id=543c17b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543c17b5",
  null
  
)

export default component.exports